const togglePageScroll = (val: boolean): void => {
  const mainPage: HTMLElement | null = document.querySelector('.mainPage')
  const body: HTMLElement | null = document.querySelector('body')
  const className = 'fullHeightIOS'

  if (val) {
    if (mainPage && body) {
      mainPage.classList.add(className)
      body.classList.add(className)
    }
    return
  }
  if (mainPage && body) {
    mainPage.classList.remove(className)
    body.classList.remove(className)
  }
}

export default togglePageScroll
